import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { bgStyles, borderStyles, flexStyles, paddingStyles } from "ui";

type Props = ComponentProps["LinkToolbar"]["Root"];
export function Root({ children, className, onMouseEnter, onMouseLeave }: Props) {
  return (
    <div
      className={classNames(
        paddingStyles.p025,
        borderStyles.neutral200,
        borderStyles.radius025,
        bgStyles.neutral0,
        flexStyles.horiz050,
        className,
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
}
